import { ContainedButton, Dialog, TextButton } from '@shared/components';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useCampaignTFunction } from '@retail/campaign/i18n';
import React from 'react';

interface Props {
  campaignName: string;
  content: React.ReactNode;
  onClose: () => void;
  onDistribute: () => void;
  isLoading: boolean;
}

export const DistributeCampaignDialog = ({
  campaignName,
  content,
  onClose,
  onDistribute,
  isLoading,
}: Props) => {
  const t = useCampaignTFunction();
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>{`${t('campaign.distribute.title')} ${campaignName}`}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <TextButton onClick={onClose} size="small">
          {t('campaign.cancel')}
        </TextButton>

        <ContainedButton loading={isLoading} onClick={onDistribute} size="small">
          {t('campaign.distribute.title')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
};
